function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 413.412L469 826.079V615.857L238.891 413.412L469 210.967V0.782227L0 413.412Z",
  fill: "white",
  fillOpacity: 0.1
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 466,
    height: 827,
    viewBox: "0 0 466 827",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/g_Vector.2b3bf2ef.svg";
export { SvgComponent as ReactComponent };